import React, { useContext } from "react";
import { useCitationsResults } from "./CitationsResults.hook";
import { CitationCard } from "./CitationCard";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";

interface CitationsResultsProps {
    placement?: "inline" | "footer";
}

export const CitationsResults: React.FC<CitationsResultsProps> = ({
    placement = "inline",
}) => {
    const { country_code } = useContext(ConfigStateContext);
    const { loading, data, error, hasCitations, hasStructuredFormat } = useCitationsResults();

    // Don't show anything while loading
    if (loading) {
        return null;
    }

    // Only hide on error when there is no usable data
    if (error && !data?.html_description) {
        return null;
    }

    // Only show if we have citations
    if (!hasCitations || !data) {
        return null;
    }

    const isUyStructured = country_code === "UY" && hasStructuredFormat;

    if (placement === "inline" && isUyStructured) {
        return null;
    }

    if (placement === "footer" && !isUyStructured) {
        return null;
    }

    return (
        <div
            style={{
                marginBottom: "0",
                width: "100%",
                flex: "0 0 100%",
            }}
        >
            <CitationCard
                citation={data}
                variant={placement === "footer" ? "guide" : "default"}
            />
        </div>
    );
};
